import React from 'react';
import useRelationship from 'Hooks/useRelationship';
import DataContainer from 'Components/UI/DataContainer';
import { OutcomeInvestmentDetailsAccountsLayout } from './OutcomeInvestmentDetailsAccountsLayout';

const OutcomeInvestmentDetailsAccountsContainer = ({ relationship }) => {
  const {
    loading,
    loadingError,
    collection,
  } = useRelationship(relationship);

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      component={OutcomeInvestmentDetailsAccountsLayout}
      componentProps={{
        collection,
      }}
    />
  );
};

export { OutcomeInvestmentDetailsAccountsContainer };
